//
// Imports
//

import { getElementOrThrow } from "@lorenstuff/browser-utilities";
import NProgress from "nprogress";

import { setActiveGlobalNavigationButton } from "../components/globals/GlobalNavigation.client.js";

//
// Locals
//

const domParser = new DOMParser();

async function fetchNewDocument(urlString: string)
{
	try
	{
		const newDocumentResponse = await fetch(urlString);

		const newDocumentHtml = await newDocumentResponse.text();

		return domParser.parseFromString(newDocumentHtml, "text/html");
	}
	catch (error)
	{
		console.error("[Pjax] fetchNewDocument error:", urlString, error);

		return null;
	}
}

function getPageName(url: URL)
{
	const
	[
		_,
		firstPart = "",
		secondPart = null,
	] = url.pathname.split("/");

	let name = firstPart;

	if (secondPart != null)
	{
		name += "-" + secondPart;
	}

	return name;
}

function getUrlBase()
{
	let base = document.location.protocol + "//" + document.location.hostname;

	if (document.location.port != "")
	{
		base += ":" + document.location.port;
	}

	return base;
}

async function changePage(inputUrlString: string, pushState = true)
{
	if (inputUrlString.startsWith("?"))
	{
		inputUrlString = document.location.pathname + inputUrlString;
	}

	const url = URL.parse(inputUrlString, getUrlBase())!;

	if (url == null)
	{
		console.error("[Pjax] changePage url is null:", inputUrlString);

		return;
	}

	const urlString = url.toString();

	NProgress.start();

	const newDocument = await fetchNewDocument(urlString);

	if (newDocument == null)
	{
		NProgress.done();

		return;
	}

	NProgress.inc();

	document.title = newDocument.title;

	const mainElement = getElementOrThrow(document, "main");
	const newMainElement = getElementOrThrow(newDocument, "main");
	mainElement.replaceWith(newMainElement);

	window.scrollTo(0, 0);

	if (pushState)
	{
		history.pushState("page", "", urlString);
	}

	const pageName = getPageName(url);

	setActiveGlobalNavigationButton(pageName);

	document.dispatchEvent(new CustomEvent("mpa:reinitialize"));

	NProgress.done();
}

//
// Utility Functions
//

export function initialisePjax()
{
	if (!document.body.classList.contains("added-popstate-listener"))
	{
		window.addEventListener("popstate", () =>
		{
			changePage(document.location.toString(), false);
		});

		document.body.classList.add("added-popstate-listener");
	}

	const anchors = document.querySelectorAll<HTMLAnchorElement>("a:not(.pjax-initialised)");

	for (const anchor of anchors)
	{
		anchor.classList.add("pjax-initialised");

		const href = anchor.getAttribute("href");

		if (href == null)
		{
			continue;
		}

		if (!href.startsWith("/") && !href.startsWith("?"))
		{
			continue;
		}

		anchor.addEventListener("click", (event) =>
		{
			if (event.ctrlKey || event.shiftKey)
			{
				return;
			}

			event.preventDefault();

			changePage(href);
		});
	}
}